export default{
  "assign_delivery": "تعيين التوصيل",
  "estimated_delivery_time": "وقت التوصيل المتوقع",
  "select_saved_driver": "-- اختر مندوب توصيل محفوظ --",
  "delivery_type": "نوع التوصيل",
  "own_delivery": "توصيل خاص",
  "partner": "شريك",
  "driver_name": "اسم السائق",
  "driver_mobile": "رقم السائق",
  "vehicle_type": "نوع المركبة (دراجة/فان/شاحنة)",
  "vehicle_number": "رقم المركبة (اختياري)",
  "partner_name": "اسم الشريك",
  "confirm_delivery": "تأكيد التوصيل",
  "assigning": "جاري التعيين..."
}